import "./ContainedIconComp.css";
import { defineComponent as n, resolveComponent as t, openBlock as r, createElementBlock as c, normalizeStyle as i, createVNode as p } from "vue";
import { IconComp as s } from "./IconComp.js";
import { _ as d } from "./_plugin-vue_export-helper.dad06003.js";
const l = n({
  components: {
    IconComp: s
  },
  props: {
    icon: String,
    height: String,
    width: String,
    color: String,
    backgroundColor: String
  },
  computed: {
    styleOverides() {
      return {
        background: this.backgroundColor ?? "#E6F0F7"
      };
    }
  }
});
function m(o, a, _, h, g, u) {
  const e = t("icon-comp");
  return r(), c("div", {
    class: "containedIcon",
    style: i(o.styleOverides)
  }, [
    p(e, {
      icon: o.icon ?? "",
      height: o.height,
      width: o.width,
      color: o.color ?? "#0068AD"
    }, null, 8, ["icon", "height", "width", "color"])
  ], 4);
}
const S = /* @__PURE__ */ d(l, [["render", m], ["__scopeId", "data-v-2e28297c"]]);
export {
  S as ContainedIconComp
};
//# sourceMappingURL=ContainedIconComp.js.map
